import {createStore, combineReducers} from "redux";
import actions from "./actions";
import cookie from "../utils/cookies";
import ls from "../utils/ls";

const state = {
  drawerLogin: false,
  drawerRegister: false,
  drawerForgetPwd: false,
  drawerSearch: false,
  cart: ls.get('SECCART') || [],
  cartCount: 0,
  cartTotalAmount: 0,
  myMenus: [
    {
      name: '我的订单',
      path: '/orderList',
      icon: 'order'
    },
    {
      name: '我的预约',
      path: '/myBooking',
      icon: 'booking',
    },
    {
      name: '收货地址',
      path: '/shippingAddress',
      icon: 'location'
    },
    {
      name: '我的优惠券',
      path: '/myCoupon',
      icon: 'coupon'
    },
    // {
    //   name: '核销码',
    //   path: '/orderQRCode',
    //   icon: 'orderQRCode'
    // },
    {
      name: '我的积分',
      path: '/myIntegral',
      icon: 'integral'
    },
  ]
};

const store = createStore(combineReducers(actions), state);
export default store;

